import React from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container, Tab, Tabs } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';
import { preRegisterSpotlightRoutes } from '~/components/Common/Spotlight/SpotlightProvider';

import useAppNavigation from '~/hooks/useAppNavigation';
import useQuery from '~/hooks/useQuery';

import {
  flightsLeafTabs,
  flightsPrimaryTabs,
  getFlightsLeafSlugForPrimaryTab,
  getFlightsSecondaryTabs,
  resolveFlightsTabSelection,
} from './flightsTabs';

preRegisterSpotlightRoutes(
  flightsLeafTabs.map((tab) => ({
    path: `/flights?tab=${tab.slug}`,
    label: `Flights / ${tab.label}`,
    section: 'Flights',
  })),
);

export function FlightsPageContainer() {
  const query = useQuery();
  const { push } = useAppNavigation();
  const selectedTab = query.get('tab');
  const { activeLeafTab, activeLeafSlug, activePrimaryTab, activePrimarySlug } =
    resolveFlightsTabSelection(selectedTab);
  const secondaryTabs = getFlightsSecondaryTabs(activePrimaryTab);
  const isPrimaryTabGrouped = secondaryTabs.length > 0;

  const title = `Flights / ${activeLeafTab.label}`;

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <PageHeader title={title} />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activePrimarySlug}
          onChange={(_, selectedPrimaryTabSlug) => {
            const selectedLeafSlug = getFlightsLeafSlugForPrimaryTab(selectedPrimaryTabSlug);

            if (selectedLeafSlug) {
              push(`/flights?tab=${selectedLeafSlug}`);
            }
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {flightsPrimaryTabs.map((tab) => (
            <Tab key={tab.slug} value={tab.slug} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      {isPrimaryTabGrouped && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeLeafSlug}
            onChange={(_, selectedSecondaryTabSlug) => push(`/flights?tab=${selectedSecondaryTabSlug}`)}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            {secondaryTabs.map((tab) => (
              <Tab key={tab.slug} value={tab.slug} label={tab.label} />
            ))}
          </Tabs>
        </Box>
      )}

      <Box mt={4}>
        <Box component={activeLeafTab.component} />
      </Box>
    </Container>
  );
}

export default FlightsPageContainer;
